import { NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BehaviourService } from '@services/behaviour.service';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { IframeService } from './services/iframe.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [NgIf, RouterOutlet, HeaderComponent],
})
export class AppComponent {
  // Inyección de dependencias
  private iframeService = inject(IframeService);
  private behaviourService = inject(BehaviourService);

  // Inicialización de variables
  public noIframe = this.iframeService.isIframe();
  public showHeader = this.behaviourService.showHeader();
}
